<template>
  <div id="products-container">
    <div class="container">
      <v-content size="thin">
        <div class="page-header">
          <h1>{{ $t('user.my_addresses') }}</h1>
        </div>

        <my-addresses />
      </v-content>
    </div>
  </div>
</template>

<script>
import VContent from '~/components/shared/v-content/VContent'
import MyAddresses from '~/components/my-addresses/MyAddresses'

export default {
  name: 'AddressesPage',
  components: {
    VContent,
    MyAddresses,
  },
  head() {
    return {
      title: this.$t('user.my_addresses'),
    }
  },
}
</script>

<style lang="scss">
@import '~/assets/css/_page-header.scss';

.my-addresses__loading {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 500px;
}

.my-addresses__empty {
  text-align: center;
}

.my-addresses__empty p {
  font-size: 15px;
}
</style>
